import { currencyCode } from 'appConfig';
import { notify } from 'components/Common/Toast';
import TransactionDetails from 'pages/Community/TransactionDetails';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchWalletInvoiceDetail, updateWalletInvoiceStatus } from 'redux/slices/wallet/WalletInvoiceDetailSlice';
import { AppDispatch, RootState } from 'redux/store';
import { sendInvoice } from 'services/sendInvoice';
import Routes from 'constants/routes';
import { isInvoiceReceiver } from 'utils/helpers';

export default function WalletInvoiceDetail() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { id = '' } = useParams();
    const [cancelButtonLoading, setCancelButtonLoading] = useState<boolean>(false);
    const [resendLoading, setResendLoading] = useState<boolean>(false);
    const { requestMoney, loading } = useSelector((state: RootState) => state.wallet.walletInvoiceDetails);
    const { defaultSVA } = useSelector((state: RootState) => state.wallet.moneyContainer);
    const { amount = 0, createdDate, username = '', subject, status, imgUrl, myRole, sentFrom, sentTo, companySender } = requestMoney || {};
    const isReceiver = isInvoiceReceiver(myRole);
    useEffect(() => {
        (async () => {
            id && dispatch(fetchWalletInvoiceDetail(String(id)));
        })();
    }, [dispatch, id]);

    const handleCancelButtonClick = async () => {
        if (!id || !defaultSVA) return;
        setCancelButtonLoading(true);
        const res = await updateWalletInvoiceStatus(id, String(defaultSVA), 'DECLINED');
        if (res?.code === 200) {
            notify('Invoice Cancelled Successfully!', 'success');
            id && dispatch(fetchWalletInvoiceDetail(String(id)));
        }
        setCancelButtonLoading(false);
    };

    const handleResendInvoice = async () => {
        if (!username) return;
        const invoice = { username, subject, amount, currencyCode };
        setResendLoading(true);
        const { payload }: any = await dispatch(sendInvoice(invoice));
        setResendLoading(false);
        if (payload?.code === 200) {
            navigate(Routes.wallet.main);
        }
    };
    const handleSendMoney = async () => {
        if (!id || !defaultSVA) return;
        setResendLoading(true);
        const res = await updateWalletInvoiceStatus(id, String(defaultSVA), 'PAID');
        // setResendLoading(false);
        if (res?.code === 200) {
            notify('Payment sent successfully', 'success');
            id && dispatch(fetchWalletInvoiceDetail(String(id)));
            navigate(Routes.wallet.main);
        }
        setResendLoading(false);
    };

    return (
        <TransactionDetails
            loading={loading}
            showButtons={!!myRole}
            cancelButtonProps={{
                loading: cancelButtonLoading,
                onClick: handleCancelButtonClick,
                disabled: status === 'DECLINED' || cancelButtonLoading,
                title: !isReceiver ? 'Cancel' : 'Decline',
            }}
            submitButtonProps={{
                loading: resendLoading,
                onClick: !isReceiver ? handleResendInvoice : handleSendMoney,
                disabled: (isReceiver && status === 'DECLINED') || resendLoading,
                title: !isReceiver ? 'Resend' : 'Send Payment',
            }}
            details={{
                confirmationCode: id,
                transactionDateTime: createdDate,
                balance: amount,
                description: subject,
                username: username ? username : companySender?.email || '',
                logoUrl: imgUrl,
                status,
                myRole,
                name: isReceiver ? sentFrom : sentTo,
            }}
        />
    );
}
